module.exports = __webpack_public_path__ + "static/img/logo-word-cover.3fc12e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/logo-word-cover.png
// module id = +x3M
// module chunks = 2